import React, { useState, useEffect } from 'react';
import {
  TextField, Button, Paper, Typography, Box, Snackbar, Alert, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import { updateProduct, getAllCategoryGroups } from '../../../../services/menuPage';

const EditProductForm = ({ initialData, onSuccess }) => {
  const [formData, setFormData] = useState({
    id: initialData.id,
    name: initialData.name || '',
    price: initialData.price || '',
    description: initialData.description || '',
    category_id: initialData.category_id || '',
    image: null,
  });

  const [categories, setCategories] = useState([]);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const data = await getAllCategoryGroups();
        setCategories(data);
      } catch (err) {
        console.error("❌ فشل في جلب المجموعات:", err.message);
      }
    };
    fetchGroups();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      await updateProduct(formData);
      setMessage({ type: 'success', text: '✅ تم تحديث المنتج بنجاح' });
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("🚫 خطأ أثناء تحديث المنتج:", error.message);
      setMessage({ type: 'error', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setMessage(null);

  return (
    <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>تعديل بيانات المنتج</Typography>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <TextField label="اسم المنتج" name="name" value={formData.name} onChange={handleChange} fullWidth margin="normal" />
        <TextField label="السعر" name="price" value={formData.price} onChange={handleChange} fullWidth margin="normal" />
        <TextField label="الوصف" name="description" value={formData.description} onChange={handleChange} fullWidth margin="normal" />

        <FormControl fullWidth margin="normal">
          <InputLabel>اختر المجموعة</InputLabel>
          <Select
            name="category_id"
            value={formData.category_id}
            onChange={handleChange}
            required
          >
            {categories.map((cat) => (
              <MenuItem key={cat.id} value={cat.id}>
                {cat.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box mt={2}>
          <input type="file" name="image" accept="image/*" onChange={handleChange} />
        </Box>

        <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }} disabled={loading}>
          {loading ? 'جارٍ التحديث...' : 'تحديث المنتج'}
        </Button>
      </form>

      {message && (
        <Snackbar open autoHideDuration={4000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={message.type} sx={{ width: '100%' }}>
            {message.text}
          </Alert>
        </Snackbar>
      )}
    </Paper>
  );
};

export default EditProductForm;
